import { Box } from '@primerai/thread';
import styled from 'styled-components';

const TextInput = styled.input`
  ${({ theme }) => `
    font-size: 1rem;
    border: none;
    box-shadow: none;
    display: block;
    transition: border-color 0.3s linear, outline-color 0.3s linear;
    width: 100%;

  &[disabled],
  &[readonly] {
    opacity: 0.7;
  }
  &[disabled] {
    cursor: not-allowed;
  }

    &[disabled] {
      cursor: not-allowed;
    }

    padding: ${theme.space.$3};
  `}
`;

export const ViewablePasswordInputWrapper = styled(Box)`
  ${({ theme }) => `
  position: relative;

  .display-toggle {
    position: absolute;
    top: 50%;
    right: ${theme.space.$3};
    margin-top: -${theme.space.$3};
    color: ${theme.colors.$grayScale.g5};

    &:hover {
      cursor: pointer;
      color: ${theme.colors.$grayScale.g9};
    }
  }
`}
`;

export const StyledInputDecorator = styled(Box)<{
  error: boolean;
}>`
  ${({ theme, error }) => `
  margin-bottom: ${theme.space.$1};
  border-bottom: 1px solid ${
    error ? theme.colors.$alerts.danger : theme.colors.$border.muted
  };
  padding-bottom: ${theme.space.$2};
  margin-top: ${theme.space.$5};
  }
`}
`;

export default TextInput;
